import { render, staticRenderFns } from "./tabKPISettings.vue?vue&type=template&id=2600e67d&scoped=true&"
import script from "./tabKPISettings.vue?vue&type=script&lang=js&"
export * from "./tabKPISettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2600e67d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2600e67d')) {
      api.createRecord('2600e67d', component.options)
    } else {
      api.reload('2600e67d', component.options)
    }
    module.hot.accept("./tabKPISettings.vue?vue&type=template&id=2600e67d&scoped=true&", function () {
      api.rerender('2600e67d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/PriceFCL/components/PriceFCL/tabKPISettings.vue"
export default component.exports